import type { FaireProductEntity } from "../../entity_types/product";

export const p_qmsurqdhx5: FaireProductEntity = {
  token: "p_qmsurqdhx5",
  type: "product",
  name: "Mountain Close To You - Customizable - 1/2 Zip Pullover",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/ca2e39f3bc2a84c24f079b4b858050c45b9c1426396cbd2f0f17e440df4ed9e8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7036cd4aa7a8cfe8ca67c85b388401ee9d2c6472644f42f13b1bf0dc49f1fa1f.png",
    "https://cdn.faire.com/fastly/0fbe07439aec09c4ea46f76028dee9dbb3473101645cdfa931b221911fc3e7b3.png",
    "https://cdn.faire.com/fastly/68a45ba9cbbc7ee6feb16e7f0d6ad3727036c18ac6abb619d780a26d2f41eef8.png",
    "https://cdn.faire.com/fastly/10b57da3b5e922feb40b357ba655c3e8187eaea311275c492bf7120c3916d405.png"
  ],
  priceDollars: 34,
  description: "We LOOOOOVE this new pullover. It has everything we love. 1/2 zip extended neck collar, all metal zipper, nicely finished zipper pull, raglan sleeves and a front pocket. The fit is true to size. Relaxed yet boxy.\nFour fun colors available in sizes X-Small through 3X-Large. The garment is made of 68% Cotton and 32% Polyester and manufactured for One Stop LLC.\n\nOur new design is customizable with your town and state. We will replace Longmont, Colorado; Sitka, Alaska; Depoe Bay, Oregon and Billings, Montana with your town and state. We will customize the design as your request the placement. We ask that in the area provided leave the name that you would like printed on the top, first and the bottom, second. For example \"Oregon/Depoe Bay\"",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:51.838Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
